// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* registrationpage.css */



.register-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #bedde2;
  }
  
  .logo-register {
    display: block;
    margin: 0 auto 0px auto;
    width: 118px; /* Adjust as necessary */
  }
  
  h2 {
    text-align: center;
    color: #0c3274;
    margin-bottom: 20px;
  }
  
  form {
    background: #ffffff;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }
  
  input[type="text"],
  input[type="email"],
  input[type="password"] {
    width: 100%;
    padding: 15px;
    margin: 10px 0;
    border: 1px solid #a8a8a8;;
    border-radius: 4px;
    box-sizing: border-box;
    display: block;
    font-size: 14px;
    transition: all 0.3s ease;
  }
  
  input[type="text"]:focus,
  input[type="email"]:focus,
  input[type="password"]:focus {
    border-color: #66c1ee;
    outline: none;
    box-shadow: 0 0 8px rgba(0, 86, 179, 0.2);
    height: 50px;
  }
  
  .LogInPageButtons {
    width: 100%;
    padding: 15px;
    background: #0c3274;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
    transition: background-color 0.3s ease;
    height: 50px;
  }
  
  .LogInPageButtons:hover {
    background-color: #272726;
  }
  
  .LogInPageButtons:focus {
    outline: none;
    box-shadow: 0 0 8px rgba(0, 86, 179, 0.2);
  }
  
  /* p {
    color: #020202;
    text-align: left;
  }
   */
  /* Adjust button alignment */
  .LogInPageButtons {
    display: block;
    margin: 20px auto;
  }
  
  .password-field-container {
    display: flex;
    align-items: center;
    position: relative;
  }
  
  .password-eye-icon {
    position: absolute;
    right: -5px;
    cursor: pointer;
    background-color: white;
  }
  
  .validation-message {
    color: red;
    font-size: 0.8em;
    margin-top: 5px;
  }`, "",{"version":3,"sources":["webpack://./src/features/authentication/registrationpage.css"],"names":[],"mappings":"AAAA,yBAAyB;;;;AAIzB;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,YAAY,EAAE,wBAAwB;EACxC;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;;;IAGE,WAAW;IACX,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,yBAAyB;EAC3B;;EAEA;;;IAGE,qBAAqB;IACrB,aAAa;IACb,yCAAyC;IACzC,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,yCAAyC;EAC3C;;EAEA;;;;IAIE;EACF,4BAA4B;EAC5B;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,eAAe;EACjB","sourcesContent":["/* registrationpage.css */\n\n\n\n.register-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #bedde2;\n  }\n  \n  .logo-register {\n    display: block;\n    margin: 0 auto 0px auto;\n    width: 118px; /* Adjust as necessary */\n  }\n  \n  h2 {\n    text-align: center;\n    color: #0c3274;\n    margin-bottom: 20px;\n  }\n  \n  form {\n    background: #ffffff;\n    padding: 40px;\n    border-radius: 8px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  input[type=\"text\"],\n  input[type=\"email\"],\n  input[type=\"password\"] {\n    width: 100%;\n    padding: 15px;\n    margin: 10px 0;\n    border: 1px solid #a8a8a8;;\n    border-radius: 4px;\n    box-sizing: border-box;\n    display: block;\n    font-size: 14px;\n    transition: all 0.3s ease;\n  }\n  \n  input[type=\"text\"]:focus,\n  input[type=\"email\"]:focus,\n  input[type=\"password\"]:focus {\n    border-color: #66c1ee;\n    outline: none;\n    box-shadow: 0 0 8px rgba(0, 86, 179, 0.2);\n    height: 50px;\n  }\n  \n  .LogInPageButtons {\n    width: 100%;\n    padding: 15px;\n    background: #0c3274;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 10px;\n    transition: background-color 0.3s ease;\n    height: 50px;\n  }\n  \n  .LogInPageButtons:hover {\n    background-color: #272726;\n  }\n  \n  .LogInPageButtons:focus {\n    outline: none;\n    box-shadow: 0 0 8px rgba(0, 86, 179, 0.2);\n  }\n  \n  /* p {\n    color: #020202;\n    text-align: left;\n  }\n   */\n  /* Adjust button alignment */\n  .LogInPageButtons {\n    display: block;\n    margin: 20px auto;\n  }\n  \n  .password-field-container {\n    display: flex;\n    align-items: center;\n    position: relative;\n  }\n  \n  .password-eye-icon {\n    position: absolute;\n    right: -5px;\n    cursor: pointer;\n    background-color: white;\n  }\n  \n  .validation-message {\n    color: red;\n    font-size: 0.8em;\n    margin-top: 5px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
